export const environment = {
    production: false,
    host: 'https://me.ahacafe.vn'
};
